import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadedFile } from '../../../../core/components/file-upload/file-upload.component';
import { ResponseBase, ScreenModel, RequestData } from '../../../../core/models/common';
import {
  FileUpload,
  FileUploadServerData,
  Investment,
  InvestmentServerData,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { BasicModalComponent } from '../../components/basic-modal/basic-modal.component';

// What we receive from the API, and will send to the API.
export interface FinancialSituationData extends ResponseBase {
  IndicatedRiskProfile?: string;
  IsInvestmentPortfolioDisclosed?: boolean;
  IsInvestmentHistoryDisclosed?: boolean;
  CurrentInvestmentPortfolio: InvestmentServerData[];
  CurrentInvestmentHistory: InvestmentServerData[];
  SelectedFinancialSituationOption?: string; //only accept this 3 string value: 'financial-statement', 'other-documents', 'non-disclosure'
  IsFinancialSituationNonDisclosureConfirm?: boolean;
  NonDisclosureFinancialSituationCapitalCurrency?: string;
  NonDisclosureFinancialSituationCapitalAmount?: number;
  IsInvestmentPortfolioNonDisclosureConfirm?: boolean;
  IsInvestmentHistoryNonDisclosureConfirm?: boolean;
  FinancialStatementDate?: string;
  FinancialStatement?: FileUploadServerData;
  OtherFinancialSituationDocument?: FileUploadServerData[];
}

// What we work with in this screen.
export class FinancialSituationModel extends ScreenModel {
  screenName = 'FinancialSituation';
  pageID_read = 'R0050';
  pageID_write = 'S0050';
  data: FinancialSituationData | undefined;
  indicatedRiskProfile?: string;
  isInvestmentPortfolioDisclosed?: boolean;
  isInvestmentHistoryDisclosed?: boolean;
  currentInvestmentPortfolio: Investment[] = [];
  currentInvestmentHistory: Investment[] = [];
  selectedFinancialSituationOption: string = 'financial-statement';
  isFinancialSituationNonDisclosureConfirm: boolean = false;
  nonDisclosureFinancialSituationCapitalCurrency?: string;
  nonDisclosureFinancialSituationCapitalAmount?: number;
  isInvestmentHistoryNonDisclosureConfirm: boolean = false;
  isInvestmentPortfolioNonDisclosureConfirm: boolean = false;
  financialStatementDate?: string;
  financialStatement?: FileUpload | undefined;
  otherFinancialSituationDocument?: FileUpload[] | undefined;

  // Data lifecycle start.

  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    let financialDetails = data['FinancialDetails']
     let financialSituationData:FinancialSituationData  = {
      IndicatedRiskProfile: financialDetails['RiskProfile']['DeclaredRiskProfile']=='Conservative'?'conservative':financialDetails['RiskProfile']['DeclaredRiskProfile']=='Moderate'?'moderate':financialDetails['RiskProfile']['DeclaredRiskProfile']=='Aggressive'?'aggressive':'',
  IsInvestmentPortfolioDisclosed: financialDetails['InvestmentPortfolio']['Type']=='CurrentInvestmentPortfolio'?true:financialDetails['InvestmentPortfolio']['Type']=='Non-Disclosure'?false:undefined,
  IsInvestmentHistoryDisclosed: financialDetails['InvestmentHistory']['Type']=='InvestmentHistory'?true:financialDetails['InvestmentHistory']['Type']=='Non-Disclosure'?false:undefined,
  CurrentInvestmentPortfolio: financialDetails['InvestmentPortfolio']['Type']=='CurrentInvestmentPortfolio'?financialDetails['InvestmentPortfolio']['InvestmentPortfolioList'].map((portfolio:any)=>{
    return{
      Name: portfolio['Investment'],
  DateOfPurchase: portfolio['DateOfPurchase']?this.getUIDate(portfolio['DateOfPurchase']):'',
  Currency: portfolio['Currency'],
  AmountInvested: portfolio['Amount'],
  TenorValue: portfolio['Tenor'],
  TenorUnit: portfolio['TenorFrequency']
    }
  }):[],
  CurrentInvestmentHistory: financialDetails['InvestmentHistory']['Type']=='InvestmentHistory'?financialDetails['InvestmentHistory']['InvestmentHistoryList'].map((portfolio:any)=>{
    return{
      Name: portfolio['Investment'],
  DateOfPurchase: portfolio['DateOfPurchase']?this.getUIDate(portfolio['DateOfPurchase']):'',
  Currency: portfolio['Currency'],
  AmountInvested: portfolio['Amount'],
  TenorValue: portfolio['Tenor'],
  TenorUnit: portfolio['TenorFrequency']
    }
  }):[],
  SelectedFinancialSituationOption: financialDetails['CurrentFinancialSituation']['Type']=='Non-Disclosure'?'non-disclosure':financialDetails['CurrentFinancialSituation']['Type']=='FinancialStatement'?'financial-statement':financialDetails['CurrentFinancialSituation']['Type']=='UploadOtherDocs'?'other-documents':'', //only accept this 3 string value: 'financial-statement', 'other-documents', 'non-disclosure'
  IsFinancialSituationNonDisclosureConfirm: financialDetails['CurrentFinancialSituation']['NonDisclosure'],
  NonDisclosureFinancialSituationCapitalCurrency: financialDetails['CurrentFinancialSituation']['Currency'],
  NonDisclosureFinancialSituationCapitalAmount: financialDetails['CurrentFinancialSituation']['Amount'],
  IsInvestmentPortfolioNonDisclosureConfirm: financialDetails['InvestmentPortfolio']['NonDisclosure'],
  IsInvestmentHistoryNonDisclosureConfirm: financialDetails['InvestmentHistory']['NonDisclosure'],
  FinancialStatementDate: financialDetails['CurrentFinancialSituation']['DateOfStatement']?this.getUIDate(financialDetails['CurrentFinancialSituation']['DateOfStatement']):'',
  FinancialStatement: financialDetails['CurrentFinancialSituation']['CapturedDocuments'][0]?{
    FileId: '',
    Name: financialDetails['CurrentFinancialSituation']['CapturedDocuments'][0]['DocName'],
    Data: financialDetails['CurrentFinancialSituation']['CapturedDocuments'][0]['Value'],
    Size: 5555,
    Type: financialDetails['CurrentFinancialSituation']['CapturedDocuments'][0]['ExtensionType'],
    DocumentType: financialDetails['CurrentFinancialSituation']['CapturedDocuments'][0]['DocumentType']
  }:undefined,
  OtherFinancialSituationDocument: financialDetails['CurrentFinancialSituation']['CapturedDocuments'].map((document:any)=>{
    return {
      FileId: '',
    Name: document['DocName'],
    Data: document['Value'],
    Size: '',
    Type: document['ExtensionType'],
    DocumentType: document['DocumentType']
    }
  })
     }
     return financialSituationData;
   }

  deriveFromData(data: FinancialSituationData) {
    
    this.indicatedRiskProfile = data.IndicatedRiskProfile;
    this.isInvestmentPortfolioDisclosed = data.IsInvestmentPortfolioDisclosed;
    this.isInvestmentHistoryDisclosed = data.IsInvestmentHistoryDisclosed;
    this.currentInvestmentPortfolio = data.CurrentInvestmentPortfolio.map(
      (investment, index) => {
        return {
          key: index,
          name: investment.Name,
          dateOfPurchase: investment.DateOfPurchase,
          currency: investment.Currency,
          amountInvested: investment.AmountInvested,
          tenorValue: investment.TenorValue,
          tenorUnit: investment.TenorUnit,
        };
      },
    );
    this.currentInvestmentHistory = data.CurrentInvestmentHistory.map(
      (investment, index) => {
        return {
          key: index,
          name: investment.Name,
          dateOfPurchase: investment.DateOfPurchase,
          currency: investment.Currency,
          amountInvested: investment.AmountInvested,
          tenorValue: investment.TenorValue,
          tenorUnit: investment.TenorUnit,
        };
      },
    );
    this.selectedFinancialSituationOption =
      data.SelectedFinancialSituationOption || 'financial-statement';
    this.isFinancialSituationNonDisclosureConfirm =
      data.IsFinancialSituationNonDisclosureConfirm || false;
    this.nonDisclosureFinancialSituationCapitalCurrency =
      data.NonDisclosureFinancialSituationCapitalCurrency;
    this.nonDisclosureFinancialSituationCapitalAmount =
      data.NonDisclosureFinancialSituationCapitalAmount;
    this.isInvestmentHistoryNonDisclosureConfirm =
      data.IsInvestmentHistoryNonDisclosureConfirm || false;
    this.isInvestmentPortfolioNonDisclosureConfirm =
      data.IsInvestmentPortfolioNonDisclosureConfirm || false;
    this.financialStatementDate = data.FinancialStatementDate;

    if (data.FinancialStatement) {
      this.financialStatement = {
        fileId: data.FinancialStatement.FileId,
        name: data.FinancialStatement.Name,
        data: data.FinancialStatement.Data,
        size: data.FinancialStatement.Size,
        type: data.FinancialStatement.Type,
        documentType: data.FinancialStatement.DocumentType,
      };
    }

    if (data.OtherFinancialSituationDocument) {
      this.otherFinancialSituationDocument =
        data.OtherFinancialSituationDocument.map((file) => {
          return {
            fileId: file.FileId,
            name: file.Name,
            data: file.Data,
            size: file.Size,
            type: file.Type,
            documentType: file.DocumentType,
          };
        });
    }
    console.log('deriveFromData, model:', this);
  }

  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): RequestData {
    // @For integration.
    console.log(this.otherFinancialSituationDocument);

    
    return {
      ServiceBody :{
        FinancialDetails : {
          CurrentFinancialSituation :{
                Type: this.selectedFinancialSituationOption=='non-disclosure'?'Non-Disclosure':this.selectedFinancialSituationOption=='financial-statement'?'FinancialStatement':this.selectedFinancialSituationOption=='other-documents'?'UploadOtherDocs':'',
                 CapturedDocuments:(this.otherFinancialSituationDocument && this.otherFinancialSituationDocument.length>0)?(
                  this.otherFinancialSituationDocument.map((file)=>{
                    return {
                        DocName: file.name,
                        Value: file.data,
                        ExtensionType: file.type,
                        DocumentType: file.documentType,
                    }
                  })
                 ):(this.financialStatement )?[{
                  DocName: this.financialStatement.name,
                  Value: this.financialStatement.data,
                  ExtensionType: this.financialStatement.type,
                  DocumentType: "xyz",
                 }]:[]
                 
                ,
                Currency: this.nonDisclosureFinancialSituationCapitalCurrency,
                Amount: this.nonDisclosureFinancialSituationCapitalAmount,
                NonDisclosure: this.isFinancialSituationNonDisclosureConfirm,
                DateOfStatement : this.financialStatementDate?this.getPegaDate(this.financialStatementDate):''
          },
          InvestmentHistory : {
            'Type': this.isInvestmentHistoryDisclosed?'InvestmentHistory':'Non-Disclosure',
            'NonDisclosure':  this.isInvestmentHistoryNonDisclosureConfirm,
            'InvestmentHistoryList': this.currentInvestmentHistory.map(
              (investment) => {
                return {
                  Investment: investment.name,
                  DateOfPurchase: investment.dateOfPurchase?this.getPegaDate(investment.dateOfPurchase):'',
                  Currency: investment.currency,
                  Amount: investment.amountInvested,
                  TenorFrequency: investment.tenorUnit,
                  Tenor: investment.tenorValue,
                };
              },
            )
           
          },
          InvestmentPortfolio : {
            'Type': this.isInvestmentPortfolioDisclosed?'CurrentInvestmentPortfolio':'Non-Disclosure',
            'NonDisclosure':  this.isInvestmentPortfolioNonDisclosureConfirm,
            'InvestmentPortfolioList': this.currentInvestmentPortfolio.map(
              (investment) => {
                return {
                  Investment: investment.name,
                  DateOfPurchase: investment.dateOfPurchase?this.getPegaDate(investment.dateOfPurchase):'',
                  Currency: investment.currency,
                  Amount: investment.amountInvested,
                  TenorFrequency: investment.tenorUnit,
                  Tenor: investment.tenorValue,
                };
              },
            )
           
          },
          RiskProfile: { 
            DeclaredRiskProfile: this.indicatedRiskProfile=='conservative'?'Conservative':this.indicatedRiskProfile=='moderate'?'Moderate':this.indicatedRiskProfile=='aggressive'?'Aggressive':''
    }

         // DeclaredRiskProfile : this.indicatedRiskProfile=='conservative'?'Conservative':this.indicatedRiskProfile=='moderate'?'Moderate':this.indicatedRiskProfile=='aggressive'?'Aggressive':''
        }
      } // this.isQualifiedAccreditedInvestor}
    };
  }
  // Data lifecycle end.

  syncModelWithForm() {
    console.log('[FinancialSituationModel] syncModelWithForm');

    const formValues = this.form?.value;

    // region Financial Situation

    // Current Financial Situation
    this.selectedFinancialSituationOption =
      formValues.selectedFinancialSituationOption;

    this.financialStatement =
      formValues.financialStatementFile?.uploadedFiles?.[0]?.file;

    this.financialStatementDate = formValues.financialStatementDate;

    this.isFinancialSituationNonDisclosureConfirm =
      formValues.isFinancialSituationNonDisclosureConfirm;

    this.nonDisclosureFinancialSituationCapitalCurrency =
      formValues.nonDisclosureFinancialSituationCapitalCurrency;

    this.nonDisclosureFinancialSituationCapitalAmount =
      formValues.nonDisclosureFinancialSituationCapitalAmount;

    // Other Financial Documents
    this.otherFinancialSituationDocument =
      formValues.otherFinancialSituationFile.uploadedFiles.map(
        (file: UploadedFile) => {
          return {
            fileId: file.file.id,
            name: file.file.name,
            size: file.file.size,
            type: file.file.type,
            data: file.file.data,
            documentType: file.documentType,
          };
        },
      );
    // endregion

    // region Investment History
    this.isInvestmentHistoryDisclosed = formValues.isInvestmentHistoryDisclosed;

    this.currentInvestmentHistory = formValues.currentInvestmentHistory.map(
      (investment: Investment) => {
        return {
          ...investment,
        };
      },
    );

    this.isInvestmentHistoryNonDisclosureConfirm =
      formValues.isInvestmentHistoryNonDisclosureConfirm;
    // endregion

    // region Investment Portfolio
    this.isInvestmentPortfolioDisclosed =
      formValues.isInvestmentPortfolioDisclosed;

    this.isInvestmentPortfolioNonDisclosureConfirm =
      formValues.isInvestmentPortfolioNonDisclosureConfirm;

    this.currentInvestmentPortfolio = formValues.currentInvestmentPortfolio.map(
      (investment: Investment) => {
        return {
          ...investment,
        };
      },
    );
    // endregion

    this.indicatedRiskProfile = formValues.indicatedRiskProfile;

    console.log('Form Values: ', formValues);
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-financial-situation',
  templateUrl: './financial-situation.component.html',
  styleUrls: ['./financial-situation.component.scss'],
})
export class FinancialSituationComponent implements OnInit {
  model = new FinancialSituationModel(this.globals, this.apiService, this.el);

  fsCurrencyList = ['SGD', 'USD'];
  tenorUnitList = ['Years', 'Months', 'Weeks'];
  DEFAULT_CURRENCY = 'SGD';
  DEFAULT_TENOR_UNIT = 'Months';
  INVALID_CHARACTERS = '~!;{}<>$%^=?"|';
  MAX_CHARACTERS = 80;

  form: FormGroup = this.formBuilder.group({
    //Financial Situation
    selectedFinancialSituationOption: [undefined, [Validators.required]],
    //--only apply if selectedFinancialSituationOption = 'financial-statement'
    financialStatementDate: [undefined],
    financialStatementFile: this.formBuilder.group({
      uploadedFiles: this.formBuilder.array([], [Validators.required]),
    }),
    //--only apply if selectedFinancialSituationOption = 'other-document'
    // otherFinancialSituationFileType: this.formBuilder.array([]),
    otherFinancialSituationFile: this.formBuilder.group({
      uploadedFiles: this.formBuilder.array([]),
    }),
    //--only apply if selectedFinancialSituationOption = 'non-disclosure'
    isFinancialSituationNonDisclosureConfirm: [undefined],
    nonDisclosureFinancialSituationCapitalCurrency: [undefined],
    nonDisclosureFinancialSituationCapitalAmount: [undefined],

    //Investment History
    isInvestmentHistoryDisclosed: [undefined, [Validators.required]],
    //--only apply if isInvestmentHistoryDisclosed = true
    currentInvestmentHistory: this.formBuilder.array([]),
    //--only apply if isInvestmentHistoryDisclosed = false
    isInvestmentHistoryNonDisclosureConfirm: [undefined],

    //Investment Portfolio
    isInvestmentPortfolioDisclosed: [undefined, [Validators.required]],
    //--only apply if isInvestmentPortfolioDisclosed = true
    currentInvestmentPortfolio: this.formBuilder.array([]),
    //--only apply if isInvestmentPortfolioDisclosed = false
    isInvestmentPortfolioNonDisclosureConfirm: [undefined],

    //Risk Profile
    indicatedRiskProfile: [undefined, [Validators.required]],
  });

  @ViewChild('confirmationModal')
  confirmationModal: ElementRef | undefined;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private modalService: NgbModal,
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.goToPreviousScreen = this.goToPreviousScreen;
    this.model.markControlsAsTouched = this.markControlsAsTouched;
  }

  async ngOnInit() {
    this.formControlValueChanged();
    await this.model.loadData();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    // region Financial Situation
    this.selectedFinancialSituationOptionControl.setValue(
      this.model.selectedFinancialSituationOption,
    );

    // region Latest financial statement
    if (this.model.selectedFinancialSituationOption === 'financial-statement') {
      if (this.model.financialStatement) {
        this.financialStatementFilesFormArray.push(
          new FormGroup({
            file: new FormControl(this.model.financialStatement, [
              Validators.required,
            ]),
          }),
        );
      }

      this.financialStatementDateControl.setValue(
        this.model.financialStatementDate,
      );
    }
    // endregion

    // region Other documents
    // --remove all otherFinancialSituationFilesFormArray controls to be added later with default values.
    if (this.model.selectedFinancialSituationOption === 'other-documents') {
      for (
        let i = this.otherFinancialSituationFilesFormArray.controls.length - 1;
        i >= 0;
        i--
      ) {
        this.otherFinancialSituationFilesFormArray.removeAt(i);
      }

      if (this.model.otherFinancialSituationDocument) {
        this.model.otherFinancialSituationDocument.forEach((file) => {
          this.otherFinancialSituationFilesFormArray.push(
            new FormGroup({
              file: new FormControl(
                {
                  id: file.fileId,
                  name: file.name,
                  size: file.size,
                  type: file.type,
                  data: file.data
                },
                [Validators.required],
              ),
              documentType: new FormControl(file.documentType),
            }),
          );
        });
      }
    }

    // endregion

    // region Non-disclosure
    this.isFinancialSituationNonDisclosureConfirmControl.setValue(
      this.model.isFinancialSituationNonDisclosureConfirm,
    );
    this.nonDisclosureFinancialSituationCapitalAmountControl.setValue(
      this.model.nonDisclosureFinancialSituationCapitalAmount,
    );
    this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValue(
      this.model.nonDisclosureFinancialSituationCapitalCurrency,
    );
    // endregion

    // --update validator
    this.updateFinancialSituation(this.model.selectedFinancialSituationOption);
    // endregion

    // region Investment History
   

    this.isInvestmentHistoryDisclosedControl.setValue(
      this.model.isInvestmentHistoryDisclosed,
    );

    this.isInvestmentHistoryNonDisclosureConfirmControl.setValue(
      this.model.isInvestmentHistoryNonDisclosureConfirm,
    );

    // --remove all currentInvestmentHistoryFormArray controls to be added later with default values.
    // for (
    //   let i = this.currentInvestmentHistoryFormArray.controls.length - 1;
    //   i >= 0;
    //   i--
    // ) {
    this.currentInvestmentHistoryFormArray.clear();
    // }

    if(this.model.isInvestmentHistoryDisclosed){
      if (this.model.currentInvestmentHistory.length > 0) {
        this.model.currentInvestmentHistory.forEach((investment) => {
          this.currentInvestmentHistoryFormArray.push(
            this.buildInvestmentFormGroup(investment),
          );
        });
      } else {
        this.addHistoryInvestmentButtonClick();
      }
    }
   
    // endregion

    // region Investment Portfolio
  

    this.isInvestmentPortfolioDisclosedControl.setValue(
      this.model.isInvestmentPortfolioDisclosed,
    );

    this.isInvestmentPortfolioNonDisclosureConfirmControl.setValue(
      this.model.isInvestmentPortfolioNonDisclosureConfirm,
    );

    //--remove all currentInvestmentPortfolioFormArray controls to be added later with default values.
    // for (
    //   let i = this.currentInvestmentPortfolioFormArray.controls.length - 1;
    //   i >= 0;
    //   i--
    // ) {
    this.currentInvestmentPortfolioFormArray.clear();
    // }
    if(this.model.isInvestmentPortfolioDisclosed){
      if (this.model.currentInvestmentPortfolio.length > 0) {
        this.model.currentInvestmentPortfolio.forEach((investment) => {
          this.currentInvestmentPortfolioFormArray.push(
            this.buildInvestmentFormGroup(investment),
          );
        });
      } else {
        this.addPortfolioInvestmentButtonClick();
      }
    }
    
    // endregion

    // region Risk Profile
    this.indicatedRiskProfileControl.setValue(this.model.indicatedRiskProfile);
    // endregion
  };

  goToNextScreen = async () => {
    console.log('[FinancialSituationComponent] goToNextScreen');
    await this.router.navigateByUrl('/fna/risk-and-objectives');
  };

  goToPreviousScreen = async () => {
    console.log('[FinancialSituationComponent] goToPreviousScreen');
    await this.router.navigateByUrl('/fna/organisation-information');
  };

  markControlsAsTouched = () => {
    this.form.markAllAsTouched();

    const financialSituationOption =
      this.selectedFinancialSituationOptionControl.value;

    if (financialSituationOption === 'financial-statement') {
      this.financialStatementDateControl.markAsTouched();
      this.financialStatementFilesFormArray.markAsTouched();
      this.otherFinancialSituationFilesFormArray.markAsUntouched();
      this.isFinancialSituationNonDisclosureConfirmControl.markAsUntouched();
      this.nonDisclosureFinancialSituationCapitalAmountControl.markAsUntouched();
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.markAsUntouched();
    } else if (financialSituationOption === 'other-documents') {
      this.financialStatementDateControl.markAsUntouched();
      this.financialStatementFilesFormArray.markAsUntouched();
      this.otherFinancialSituationFilesFormArray.markAsTouched();
      this.isFinancialSituationNonDisclosureConfirmControl.markAsUntouched();
      this.nonDisclosureFinancialSituationCapitalAmountControl.markAsUntouched();
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.markAsUntouched();
    } else if (financialSituationOption === 'non-disclosure') {
      this.financialStatementDateControl.markAsUntouched();
      this.financialStatementFilesFormArray.markAsUntouched();
      this.otherFinancialSituationFilesFormArray.markAsUntouched();
      this.isFinancialSituationNonDisclosureConfirmControl.markAsTouched();
      this.nonDisclosureFinancialSituationCapitalAmountControl.markAsTouched();
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.markAsTouched();
    }

    this.financialStatementDateControl.updateValueAndValidity();
    this.financialStatementFilesFormArray.updateValueAndValidity();
    this.otherFinancialSituationFilesFormArray.updateValueAndValidity();
    this.isFinancialSituationNonDisclosureConfirmControl.updateValueAndValidity();
    this.nonDisclosureFinancialSituationCapitalAmountControl.updateValueAndValidity();
    this.nonDisclosureFinancialSituationCapitalCurrencyControl.updateValueAndValidity();

    console.log(
      'markControlsAsTouched [isFinancialSituationNonDisclosureConfirmControl]',
      this.isFinancialSituationNonDisclosureConfirmControl.touched,
    );
  };

  characterLimit(
    event: any,
    maxLength: number,
    formControl: AbstractControl | null,
  ) {
    if (formControl === null) {
      event.target.value = '';
    } else {
      if (event.target.value.length > maxLength) {
        const value = event.target.value.slice(0, maxLength);
        event.target.value = value;
        formControl.setValue(value);
      } else {
        formControl.setValue(event.target.value);
      }
    }
  }

  buildInvestmentFormGroup(investment: Investment): FormGroup {
    const excludeCharactersRegex = '[^' + this.INVALID_CHARACTERS + ']+';
    const group = this.formBuilder.group({
      name: [
        '',
        [
          Validators.required,
          Validators.pattern(excludeCharactersRegex),
          Validators.maxLength(this.MAX_CHARACTERS),
        ],
      ],
      dateOfPurchase: ['', Validators.required],
      currency: ['SGD', Validators.required],
      amountInvested: ['', Validators.required],
      tenorValue: ['', Validators.required],
      tenorUnit: ['Months', Validators.required],
    });

    const newGroupValues = {
      name: investment.name,
      dateOfPurchase: investment.dateOfPurchase,
      currency: investment.currency || 'SGD',
      amountInvested: investment.amountInvested,
      tenorValue: investment.tenorValue,
      tenorUnit: investment.tenorUnit || 'Months',
    };
    group.patchValue(newGroupValues);

    return group;
  }

  addPortfolioInvestmentButtonClick(): void {
    const newInvestment = {
      name: '',
      dateOfPurchase: '',
      currency: 'SGD',
      amountInvested: undefined,
      tenorValue: undefined,
      tenorUnit: 'Months',
    };
    this.currentInvestmentPortfolioFormArray.push(
      this.buildInvestmentFormGroup(newInvestment),
    );
  }

  removePortfolioInvestmentButtonClick(index: number): void {
    this.currentInvestmentPortfolioFormArray.removeAt(index);
  }

  addHistoryInvestmentButtonClick(): void {
    const newInvestment = {
      name: '',
      dateOfPurchase: '',
      currency: 'SGD',
      amountInvested: undefined,
      tenorValue: undefined,
      tenorUnit: 'Months',
    };
    this.currentInvestmentHistoryFormArray.push(
      this.buildInvestmentFormGroup(newInvestment),
    );
  }

  removeHistoryInvestmentButtonClick(index: number): void {
    this.currentInvestmentHistoryFormArray.removeAt(index);
  }

  selectedFinancialSituationOptionClick(
    event: any,
    radioValue: string,
    className: string,
  ) {
    let shouldPromptUser = false;
    const selectedFinancialSituationRadio =
      this.selectedFinancialSituationOptionControl.value;

    if (radioValue === selectedFinancialSituationRadio) {
      return;
    }

    if (
      selectedFinancialSituationRadio == 'financial-statement' &&
      this.financialStatementFilesFormArray.length > 0
    ) {
      shouldPromptUser = true;
    } else if (
      selectedFinancialSituationRadio == 'other-documents' &&
      this.otherFinancialSituationFilesFormArray.length > 0
    ) {
      shouldPromptUser = true;
    } else if (
      selectedFinancialSituationRadio == 'non-disclosure' &&
      this.isFinancialSituationNonDisclosureConfirmControl.value
    ) {
      shouldPromptUser = true;
    }

    if (shouldPromptUser) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              console.log('event.target.value: ', event);
              this.selectedFinancialSituationOptionControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
      return;
    }

    if (this.globals.isLessThan1200Width) {
      this.scrollToSelectedSection(className);
    }

    this.selectedFinancialSituationOptionControl.setValue(radioValue);
  }

  selectedInvestmentHistoryClick(
    event: any,
    radioValue: boolean,
    className: string,
  ) {
    let shouldPromptUser = false;
    const isInvestmentHistoryDisclosed =
      this.isInvestmentHistoryDisclosedControl.value;

    if (radioValue == isInvestmentHistoryDisclosed) {
      return;
    }

    if (
      isInvestmentHistoryDisclosed &&
      (!this.isInvestmentFormArrayEmpty(
        this.currentInvestmentHistoryFormArray,
      ) ||
        this.currentInvestmentHistoryFormArray.dirty)
    ) {
      shouldPromptUser = true;
    } else if (
      !isInvestmentHistoryDisclosed &&
      this.isInvestmentHistoryNonDisclosureConfirmControl.value
    ) {
      shouldPromptUser = true;
    }

    if (shouldPromptUser) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              this.isInvestmentHistoryDisclosedControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
      return;
    }

    if (this.globals.isLessThan1200Width) {
      this.scrollToSelectedSection(className);
    }

    this.isInvestmentHistoryDisclosedControl.setValue(radioValue);
  }

  selectedInvestmentPortfolioClick(
    event: any,
    radioValue: boolean,
    className: string,
  ) {
    let shouldPromptUser = false;
    const isInvestmentPortfolioDisclosed =
      this.isInvestmentPortfolioDisclosedControl.value;

    if (radioValue == isInvestmentPortfolioDisclosed) {
      return;
    }

    if (
      isInvestmentPortfolioDisclosed &&
      (!this.isInvestmentFormArrayEmpty(
        this.currentInvestmentPortfolioFormArray,
      ) ||
        this.currentInvestmentPortfolioFormArray.dirty)
    ) {
      shouldPromptUser = true;
    } else if (
      !isInvestmentPortfolioDisclosed &&
      this.isInvestmentPortfolioNonDisclosureConfirmControl.value
    ) {
      shouldPromptUser = true;
    }

    if (shouldPromptUser) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              this.isInvestmentPortfolioDisclosedControl.setValue(radioValue);
            }
          },
          (reason) => {},
        );
      return;
    }

    if (this.globals.isLessThan1200Width) {
      this.scrollToSelectedSection(className);
    }

    this.isInvestmentPortfolioDisclosedControl.setValue(radioValue);
  }

  scrollToSelectedSection(className: string): void {
    const selectedElement: HTMLElement | null =
      this.el.nativeElement.querySelector('.' + className);

    if (selectedElement === null) {
      return;
    }

    setTimeout(() => {
      const radioOffset = 128;
      // firstInvalidControl.focus(); //without smooth behavior
      window.scroll({
        top:
          selectedElement.getBoundingClientRect().top +
          window.scrollY -
          radioOffset,
        left: 0,
        behavior: 'smooth',
      });
    }, 0);
  }

  isInvestmentFormArrayEmpty(formArray: FormArray) {
    if (formArray.controls.length > 1) {
      return false;
    }

    if (formArray.controls.length == 0) {
      return true;
    }

    for (let i = 0; i < formArray.controls.length; i++) {
      // console.log(formArray.controls[i]);
      const formGroup = formArray.controls[i] as FormGroup;
      // console.log('Form Controls: ', formGroup.controls);
      for (let key in formGroup.controls) {
        if (key == 'currency') {
          if (formGroup.controls[key].value !== this.DEFAULT_CURRENCY) {
            return false;
          }
          continue;
        }
        if (key == 'tenorUnit') {
          if (formGroup.controls[key].value !== this.DEFAULT_TENOR_UNIT) {
            return false;
          }
          continue;
        }
        // console.log('formGroup.controls[key]', formGroup.controls[key]);
        // console.log(
        //   'formGroup.controls[key].value',
        //   formGroup.controls[key].value,
        // );
        if (formGroup.controls[key].value) {
          return false;
        }
      }
    }

    return true;
  }

  clearFinancialStatementDate() {
    this.financialStatementDateControl.setValue(undefined);
    this.financialStatementDateControl.markAsUntouched();
    this.financialStatementDateControl.markAsPristine();
    this.financialStatementDateControl.updateValueAndValidity();
  }

  showFileUploadErrorModal(message: string) {
    const modalRef = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.componentInstance.title = 'Unable to upload file';
    modalRef.componentInstance.content = message;
    modalRef.componentInstance.buttonText = 'Okay';
  }

  // region Form controls validation

  formControlValueChanged() {
    this.selectedFinancialSituationOptionControl.valueChanges.subscribe(
      (selectedValue: string) => {
        this.updateFinancialSituation(selectedValue);
      },
    );
    this.isInvestmentHistoryDisclosedControl.valueChanges.subscribe(
      (selectedValue: boolean) => {
        this.updateInvestmentHistoryValidator(selectedValue);
      },
    );
    this.isInvestmentPortfolioDisclosedControl.valueChanges.subscribe(
      (selectedValue: boolean) => {
        this.updateInvestmentPortfolioValidator(selectedValue);
      },
    );
  }

  updateFinancialSituation(financialSituationOption: string) {
    console.log(
      '[updateFinancialSituationValidator]:',
      financialSituationOption,
    );

    if (financialSituationOption === 'financial-statement') {
      // this.financialStatementDateControl.setValidators([Validators.required);
      this.financialStatementFilesFormArray.setValidators([
        Validators.required,
      ]);
      this.otherFinancialSituationFilesFormArray.clearValidators();
      this.otherFinancialSituationFilesFormArray.clear();
      this.isFinancialSituationNonDisclosureConfirmControl.clearValidators();
      this.nonDisclosureFinancialSituationCapitalAmountControl.clearValidators();
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.clearValidators();

      // TODO: Make sure nondisclosure fields are ALL cleared
      this.isFinancialSituationNonDisclosureConfirmControl.setValue(false);
      this.nonDisclosureFinancialSituationCapitalAmountControl.setValue(
        undefined,
      );
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValue(
        undefined,
      );
    } else if (financialSituationOption === 'other-documents') {
      this.financialStatementDateControl.clearValidators();
      this.financialStatementFilesFormArray.clearValidators();
      this.financialStatementFilesFormArray.clear();
      this.financialStatementDateControl.setValue(undefined);
      this.otherFinancialSituationFilesFormArray.setValidators([
        Validators.required,
      ]);
      this.isFinancialSituationNonDisclosureConfirmControl.clearValidators();
      this.nonDisclosureFinancialSituationCapitalAmountControl.clearValidators();
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValue(
        undefined,
      );
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.clearValidators();

      // TODO: Make sure nondisclosure fields are ALL cleared
      this.isFinancialSituationNonDisclosureConfirmControl.setValue(false);
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValue(
        undefined,
      );
    } else if (financialSituationOption === 'non-disclosure') {
      this.financialStatementDateControl.clearValidators();
      this.financialStatementFilesFormArray.clearValidators();
      this.financialStatementFilesFormArray.clear();
      this.financialStatementDateControl.setValue(undefined);
      this.otherFinancialSituationFilesFormArray.clearValidators();
      this.otherFinancialSituationFilesFormArray.clear();
      this.isFinancialSituationNonDisclosureConfirmControl.setValidators([
        Validators.requiredTrue,
      ]);
      this.nonDisclosureFinancialSituationCapitalAmountControl.setValidators([
        Validators.required,
      ]);
      this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValidators([
        Validators.required,
      ]);
      if (
        this.nonDisclosureFinancialSituationCapitalCurrencyControl.value ===
        undefined
      ) {
        this.nonDisclosureFinancialSituationCapitalCurrencyControl.setValue(
          this.DEFAULT_CURRENCY,
        );
      }
    }

    this.financialStatementDateControl.markAsUntouched();
    this.financialStatementFilesFormArray.markAsUntouched();
    this.otherFinancialSituationFilesFormArray.markAsUntouched();
    this.isFinancialSituationNonDisclosureConfirmControl.markAsUntouched();
    this.nonDisclosureFinancialSituationCapitalAmountControl.markAsUntouched();
    this.nonDisclosureFinancialSituationCapitalCurrencyControl.markAsUntouched();

    this.financialStatementDateControl.markAsPristine();
    this.financialStatementFilesFormArray.markAsPristine();
    this.otherFinancialSituationFilesFormArray.markAsPristine();
    this.isFinancialSituationNonDisclosureConfirmControl.markAsPristine();
    this.nonDisclosureFinancialSituationCapitalAmountControl.markAsPristine();
    this.nonDisclosureFinancialSituationCapitalCurrencyControl.markAsPristine();

    this.financialStatementDateControl.updateValueAndValidity();
    this.financialStatementFilesFormArray.updateValueAndValidity();
    this.otherFinancialSituationFilesFormArray.updateValueAndValidity();
    this.isFinancialSituationNonDisclosureConfirmControl.updateValueAndValidity();
    this.nonDisclosureFinancialSituationCapitalAmountControl.updateValueAndValidity();
    this.nonDisclosureFinancialSituationCapitalCurrencyControl.updateValueAndValidity();
  }

  updateInvestmentHistoryValidator(isInvestmentHistoryDisclosed: boolean) {
    this.currentInvestmentHistoryFormArray.clear();
    
    if (isInvestmentHistoryDisclosed) {
      console.log('InvestmentHistoryDisclosed');
      this.isInvestmentHistoryNonDisclosureConfirmControl.setValue(false);
      this.isInvestmentHistoryNonDisclosureConfirmControl.clearValidators();
      if (this.currentInvestmentHistoryFormArray.length <= 0) {
        this.addHistoryInvestmentButtonClick();
      }
    } else {
      console.log('InvestmentHistoryNotDisclosed');
      this.isInvestmentHistoryNonDisclosureConfirmControl.setValidators([
        Validators.requiredTrue,
      ]);
    }

    this.isInvestmentHistoryNonDisclosureConfirmControl.markAsUntouched();
    this.currentInvestmentHistoryFormArray.markAsUntouched();

    this.isInvestmentHistoryNonDisclosureConfirmControl.markAsPristine();
    this.currentInvestmentHistoryFormArray.markAsPristine();

    this.isInvestmentHistoryNonDisclosureConfirmControl.updateValueAndValidity();
    this.currentInvestmentHistoryFormArray.updateValueAndValidity();
  }

  updateInvestmentPortfolioValidator(isInvestmentPortfolioDisclosed: boolean) {
    this.currentInvestmentPortfolioFormArray.clear();
    if (isInvestmentPortfolioDisclosed) {
      this.isInvestmentPortfolioNonDisclosureConfirmControl.setValue(false);
      this.isInvestmentPortfolioNonDisclosureConfirmControl.clearValidators();
      if (this.currentInvestmentPortfolioFormArray.length <= 0) {
        this.addPortfolioInvestmentButtonClick();
      }
    } else {
      this.isInvestmentPortfolioNonDisclosureConfirmControl.setValidators([
        Validators.requiredTrue,
      ]);
    }

    this.isInvestmentPortfolioNonDisclosureConfirmControl.markAsUntouched();
    this.currentInvestmentPortfolioFormArray.markAsUntouched();

    this.isInvestmentPortfolioNonDisclosureConfirmControl.markAsPristine();
    this.currentInvestmentPortfolioFormArray.markAsPristine();

    this.isInvestmentPortfolioNonDisclosureConfirmControl.updateValueAndValidity();
    this.currentInvestmentPortfolioFormArray.updateValueAndValidity();
  }

  // endregion

  // region Form controls getters

  // Current Financial Situation
  get selectedFinancialSituationOptionControl() {
    return this.form.get('selectedFinancialSituationOption') as FormControl;
  }
  get financialStatementDateControl() {
    return this.form.get('financialStatementDate') as FormControl;
  }
  get financialStatementFilesFormGroup() {
    return this.form.get('financialStatementFile') as FormGroup;
  }
  get financialStatementFilesFormArray() {
    return this.financialStatementFilesFormGroup.get(
      'uploadedFiles',
    ) as FormArray;
  }
  get otherFinancialSituationFilesFormGroup() {
    return this.form.get('otherFinancialSituationFile') as FormGroup;
  }
  get otherFinancialSituationFilesFormArray() {
    return this.otherFinancialSituationFilesFormGroup.get(
      'uploadedFiles',
    ) as FormArray;
  }
  get isFinancialSituationNonDisclosureConfirmControl() {
    return this.form.get(
      'isFinancialSituationNonDisclosureConfirm',
    ) as FormControl;
  }
  get nonDisclosureFinancialSituationCapitalAmountControl() {
    return this.form.get(
      'nonDisclosureFinancialSituationCapitalAmount',
    ) as FormControl;
  }
  get nonDisclosureFinancialSituationCapitalCurrencyControl() {
    return this.form.get(
      'nonDisclosureFinancialSituationCapitalCurrency',
    ) as FormControl;
  }

  // Investment History
  get currentInvestmentHistoryFormArray() {
    return this.form.get('currentInvestmentHistory') as FormArray;
  }
  get isInvestmentHistoryDisclosedControl() {
    return this.form.get('isInvestmentHistoryDisclosed') as FormControl;
  }
  get isInvestmentHistoryNonDisclosureConfirmControl() {
    return this.form.get(
      'isInvestmentHistoryNonDisclosureConfirm',
    ) as FormControl;
  }

  // Investment Portfolio
  get currentInvestmentPortfolioFormArray() {
    return this.form.get('currentInvestmentPortfolio') as FormArray;
  }
  get isInvestmentPortfolioDisclosedControl() {
    return this.form.get('isInvestmentPortfolioDisclosed') as FormControl;
  }
  get isInvestmentPortfolioNonDisclosureConfirmControl() {
    return this.form.get(
      'isInvestmentPortfolioNonDisclosureConfirm',
    ) as FormControl;
  }

  // Risk Profile
  get indicatedRiskProfileControl() {
    return this.form.get('indicatedRiskProfile') as FormControl;
  }

  // endregion

  get investmentCurrencyList(): string[] {
    return this.globals.model.InvestmentCurrencyList;
  }

  // region mock
  fillFormWithMockData() {
    this.selectedFinancialSituationOptionControl.setValue('non-disclosure');
    this.isFinancialSituationNonDisclosureConfirmControl.setValue(true);
    this.nonDisclosureFinancialSituationCapitalAmountControl.setValue(100000);

    this.isInvestmentHistoryDisclosedControl.setValue(false);
    this.isInvestmentHistoryNonDisclosureConfirmControl.setValue(true);

    this.isInvestmentPortfolioDisclosedControl.setValue(false);
    this.isInvestmentPortfolioNonDisclosureConfirmControl.setValue(true);

    this.indicatedRiskProfileControl.setValue('conservative');
  }
  // endregion
}
